import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const transitionLogSchema = z.object({
  id: idSchema,
  payee_case_id: idSchema,
  transition: z.string(),
  result: z.enum(['success', 'failed']),
  transition_data: z.unknown(),
  ...timestamps,
});